import { get, writable } from "svelte/store";

const openDropdown = writable(null);

export const handleDropdownOpen = (newDropdown) => {
  const dropdown = get(openDropdown);
  if (dropdown) dropdown.close();
  openDropdown.set(newDropdown);
};
